<template>
  <div
    class="card mb-5 mb-xl-10"
    id="profile_details_view"
  >
    <BlockUI :loading="block" />
    <!--begin::Card header-->
    <div class="card-header">
      <!--begin::Card title-->
      <div class="card-title m-0">
        <h3 class="fw-bolder m-0 fs-4 text-gray-800">
          {{ translate("UserTimeLine") }}
        </h3>
      </div>
    </div>

    <div
      class="card-body h-500px scroll pe-17"
      @scroll="scrollPage($event)"
    >
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in activityList"
          :key="index"
          :timestamp="
            activity.CreatedOn.split('T')[0] +
            ' ' +
            activity.CreatedOn.split('T')[1]
          "
          :type="'primary'"
          :hollow="true"
          placement="top"
        >
          <div class="card p-4 shadow-sm border">
            <h5 class="text-gray-800 m-0">{{ activity.Comment }}</h5>
            <p class="text-gray-600 m-0 fs-6">
              {{ user.firstName + " " + user.lastName }}
            </p>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script setup>
import UsersModule from "@/store/modules/Users/UsersModule";
import { ref, inject } from "vue";
import { useI18n } from "vue-i18n";
// Multi Language
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const block = ref(true);
const activityList = ref([]);
const user = inject("user");
const filterObject = {
  page: 1,
  pageSize: 20,
  userId: 0,
};
filterObject.userId = user.id;

const getActiviy = (filterObject) => {
  UsersModule.actions
    .GET_USER_ACTIVITIES(null, filterObject)
    .then((response) => {
      if (response.ListItems.length > 0) {
        response.ListItems.forEach((element) => {
          activityList.value.push(element);
        });
      }
    })
    .finally(() => (block.value = false));
};

function scrollPage(e) {
  let value = e.target.offsetHeight + Math.ceil(e.target.scrollTop);
  if (value >= e.target.scrollHeight) {
    filterObject.page = filterObject.page + 1;
    getActiviy(filterObject);
  }
}

getActiviy(filterObject);
</script>

<style scoped></style>
